import { CLIP_COMMENTS } from "MVVM/GraphQL/clipComments";
import { CommentsViewModel } from "../Common/ViewModel";
import { IClipCommentsData } from "./@types";

interface IClipCommentsViewModelProps {
  clipId: string;
}

const getClipConnection = (data: any) => data?.clip?.comments;

const ClipCommentsViewModel = ({ clipId }: IClipCommentsViewModelProps) => {
  const {
    connection,
    error,
    loading,
    loadMoreComments,
    hasNextPage,
    isLoadingMore,
  } = CommentsViewModel({
    query: CLIP_COMMENTS,
    variables: { id: clipId },
    getConnection: getClipConnection,
  });

  const data: IClipCommentsData | null = connection
    ? { clip: { id: clipId, comments: connection } }
    : null;

  return { data, error, loading, loadMoreComments, hasNextPage, isLoadingMore };
};

export { ClipCommentsViewModel };
